import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
// import { RecaptchaErrorParameters } from 'ng-recaptcha';
import { RecaptchaModel } from '../model/recaptcha.model';

@Component({
    selector: 'app-recaptcha',
    templateUrl: './recaptcha.component.html',
    styleUrls: ['./recaptcha.component.scss']
})
export class RecaptchaComponent implements OnInit {
    @Input() form!: UntypedFormGroup;
    recaptchaModel: RecaptchaModel = {};

    constructor() {}

    ngOnInit() {}

    resolved(captchaResponse: any) {}

    // public onError(errorDetails: RecaptchaErrorParameters): void {}
}
